// for reference: https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-screen-tabs/#api-group-screen-tabs

export var baseRequiredReadScopes = {
  granular: ['read:screen-tab:jira'],
  coarse: ['read:jira-work', 'manage:jira-configuration', 'manage:jira-project']
};
export var baseRequiredWriteScopes = {
  granular: ['write:screen-tab:jira'],
  coarse: ['write:jira-work', 'manage:jira-configuration', 'manage:jira-project']
};